import { render, staticRenderFns } from "./FruitWallet.vue?vue&type=template&id=38630f2c&scoped=true&"
import script from "./FruitWallet.vue?vue&type=script&lang=js&"
export * from "./FruitWallet.vue?vue&type=script&lang=js&"
import style0 from "./FruitWallet.vue?vue&type=style&index=0&id=38630f2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38630f2c",
  null
  
)

export default component.exports